import React from 'react'
import { RED, HOT_PINK } from '@styles/colors'
const Error = () => {
  return (
    <svg
      fill='none'
      height='165'
      viewBox='0 0 164 165'
      width='164'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M155.871 151.067a3.985 3.985 0 01.154 4.422 3.982 3.982 0 01-4.025 1.836H12a3.983 3.983 0 01-3.871-6.258L78.871 9.59c1.722-3.444 4.536-3.444 6.258 0l70.742 141.477z'
        stroke='url(#paint0_linear)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='13.917'
      />
      <path
        d='M82 111.853v-49'
        stroke='url(#paint1_linear)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='6.958'
      />
      <path
        d='M81.937 125.853a1.722 1.722 0 00-1.687 1.785 1.786 1.786 0 001.778 1.715h.035a1.717 1.717 0 001.687-1.785 1.785 1.785 0 00-1.75-1.715h-.035'
        stroke='url(#paint2_linear)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='6.958'
      />
      <defs>
        <linearGradient
          gradientUnits='userSpaceOnUse'
          id='paint0_linear'
          x1='18.124'
          x2='156.621'
          y1='82.192'
          y2='82.192'
        >
          <stop stopColor={RED} />
          <stop
            offset='1'
            stopColor={HOT_PINK}
          />
        </linearGradient>
        <linearGradient
          gradientUnits='userSpaceOnUse'
          id='paint1_linear'
          x1='82.072'
          x2='83'
          y1='87.353'
          y2='87.353'
        >
          <stop stopColor={RED} />
          <stop
            offset='1'
            stopColor={HOT_PINK}
          />
        </linearGradient>
        <linearGradient
          gradientUnits='userSpaceOnUse'
          id='paint2_linear'
          x1='80.501'
          x2='83.751'
          y1='127.603'
          y2='127.603'
        >
          <stop stopColor={RED} />
          <stop
            offset='1'
            stopColor={HOT_PINK}
          />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Error
